/**
 * Journey Video Block — view.js
 *
 * After a successful CF7 submission inside this section,
 * automatically trigger a PDF download on the user's device.
 * The email sent by CF7 is NOT affected — this is purely client-side.
 */

( function () {
	'use strict';

	function todayStr() {
		var d = new Date();
		return d.getFullYear() + '-' +
			String( d.getMonth() + 1 ).padStart( 2, '0' ) + '-' +
			String( d.getDate() ).padStart( 2, '0' );
	}

	/* ── Set min attribute on all event-date inputs inside this block ── */
	document.querySelectorAll( '.jvb-section input[name="event-date"]' ).forEach( function ( input ) {
		input.setAttribute( 'min', todayStr() );
	} );

	/* ── Block CF7 submission if a past date was typed manually ── */
	document.addEventListener( 'wpcf7beforesubmit', function ( event ) {
		var section = event.target.closest( '.jvb-section' );
		if ( ! section ) { return; }

		var input = section.querySelector( 'input[name="event-date"]' );
		if ( ! input || ! input.value ) { return; }

		if ( input.value < todayStr() ) {
			event.preventDefault();
			event.stopImmediatePropagation();

			input.setCustomValidity( 'Please select today or a future date.' );
			input.reportValidity();

			var tip = input.closest( '.wpcf7-form-control-wrap' );
			if ( tip ) {
				var existing = tip.querySelector( '.wpcf7-not-valid-tip' );
				if ( ! existing ) {
					var span = document.createElement( 'span' );
					span.className = 'wpcf7-not-valid-tip';
					span.setAttribute( 'role', 'alert' );
					span.textContent = 'Please select today or a future date.';
					tip.appendChild( span );
				}
			}
			input.classList.add( 'wpcf7-not-valid' );
		}
	}, true );

	/* ── Clear custom validity on change ── */
	document.querySelectorAll( '.jvb-section input[name="event-date"]' ).forEach( function ( input ) {
		input.addEventListener( 'change', function () {
			input.setCustomValidity( '' );
			input.classList.remove( 'wpcf7-not-valid' );
			var wrap = input.closest( '.wpcf7-form-control-wrap' );
			if ( wrap ) {
				var tip = wrap.querySelector( '.wpcf7-not-valid-tip' );
				if ( tip ) { tip.remove(); }
			}
		} );
	} );

	/* ── PDF download after successful submission ── */
	document.addEventListener( 'wpcf7mailsent', function ( event ) {
		var section = event.target.closest( '.jvb-section' );
		if ( ! section ) { return; }

		var pdfUrl = section.dataset.pdfUrl;
		if ( ! pdfUrl ) { return; }

		var link = document.createElement( 'a' );
		link.href     = pdfUrl;
		link.download = 'CSR-Proposal-DreamGirlFoundation.pdf';
		link.style.display = 'none';
		document.body.appendChild( link );

		setTimeout( function () {
			link.click();
			document.body.removeChild( link );
		}, 500 );
	}, false );

} )();
